{
  "de": {
    "task_assignment": {
      "actions": {
        "confirm": "Als erledigt markieren",
        "create": "Aufgabe",
        "move_to_draft": "Auf Entwurf setzen",
        "reopen": "Erneut öffnen",
        "send_and_notify": "Senden und benachrichtigen"
      },
      "assignee_types": {
        "customer": "Kunde",
        "employee": "Mitarbeiter",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Verantwortlich",
        "assignees": "Verantwortliche",
        "created_at": "Erstellt",
        "due_date": "Frist",
        "project": "Projekt",
        "status": "Status",
        "task": "Aufgabe",
        "unit": "Einheit"
      },
      "confirm": {
        "affected": "Das betrifft {customers} und {team}.",
        "affected_customers": "Das betrifft {customers}.",
        "affected_team": "Das betrifft {team}.",
        "complete_body": "Ihre Aufgaben werden für sie abgeschlossen und verschwinden aus ihrer Liste, auch wenn sie nichts getan haben.",
        "complete_header": "Diese Aufgabe für alle abschließen?",
        "customer_tasks": "{count} Kundenaufgabe | {count} Kundenaufgaben",
        "draft_body": "Die Aufgabe verschwindet, bis sie erneut gesendet wird. Bereits verschickte E-Mails bleiben verschickt.",
        "draft_header": "Diese Aufgabe wieder auf Entwurf setzen?",
        "send_customers": "Kunden sehen die Aufgabe sofort in ihrem Portal und werden benachrichtigt.",
        "send_header": "An die Verantwortlichen senden?",
        "send_permanent": "Das Senden lässt sich nicht rückgängig machen. Die Aufgabe später wieder auf Entwurf zu setzen nimmt die Benachrichtigung nicht zurück.",
        "send_status": "Sie stehen dann auf Angefragt.",
        "send_team": "Teammitglieder werden benachrichtigt.",
        "team_tasks": "{count} Teamaufgabe | {count} Teamaufgaben"
      },
      "labels": {
        "add_assignee": "Verantwortliche Person hinzufügen …",
        "add_customers": "Kunden hinzufügen",
        "already_assigned": "Diese Aufgabe wurde dieser Einheit bereits hinzugefügt.",
        "already_assigned_project": "Diese Aufgabe wurde diesem Projekt bereits hinzugefügt.",
        "completed": "Erledigt",
        "confirm_message": "Möchten Sie diese Aufgabe wirklich als erledigt markieren?",
        "customers": "Kunden",
        "my_tasks": "Meine Aufgaben",
        "no_assignees": "Noch keine Verantwortlichen.",
        "no_assignments": "Noch keine Aufgaben.",
        "no_assignments_task": "Noch keine Zuweisungen für diese Aufgabe.",
        "no_assignments_unit": "Noch keine Aufgaben für diese Einheit.",
        "required": "Dieses Feld ist erforderlich",
        "select_task": "Aufgabe auswählen",
        "upload_hint": "Laden Sie die angeforderten Dokumente hoch, um diese Aufgabe zu erledigen.",
        "uploaded_documents": "Hochgeladene Dokumente"
      },
      "statuses": {
        "completed": "Erledigt",
        "draft": "Entwurf",
        "requested": "Angefragt"
      },
      "toasts": {
        "completed": "Aufgabe erledigt",
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "reopened": "Aufgabe wieder geöffnet",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
